'use client';

import { freddyTheme, Link, SpriteIcon } from '@coolblue-development/freddy';
import selectCategoryInBreadcrumbsTrigger from '@coolblue-development/ga4-events/triggers/Breadcrumbs/selectCategoryInBreadcrumbsTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useRouter } from 'next/navigation';
import type { MouseEvent } from 'react';
import { ReactElement } from 'react';

export const BackButtonLink = ({
  href,
  withReferrer,
  children
}: {
  href?: string | null;
  withReferrer: boolean;
  children: ReactElement;
}) => {
  const router = useRouter();
  const { trackEvent } = useAnalytics();

  if (!href) return null;

  const trackingParams: Parameters<typeof selectCategoryInBreadcrumbsTrigger>[0] = {
    index: 1,
    total_indices: 1,
    url: href,
    redirect: 'back',
    sub_feature: 'horizontal_breadcrumbs'
  };

  const onBackButtonClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (withReferrer) {
      event.preventDefault();
      router.back();
    }
    trackEvent(selectCategoryInBreadcrumbsTrigger(trackingParams));
  };

  return (
    <Link
      href={href}
      startIcon={<SpriteIcon name='arrow-left' fill={freddyTheme.color.icon.base} />}
      onClick={onBackButtonClick}
    >
      {children}
    </Link>
  );
};
